import React from "react";
import { Purchase } from "../../data/purchase";
import { Card } from "../ui/Card";
import { NumberInput } from "../ui/Input";
import { SectionLabel } from "../ui/SectionLabel";
import { SmallIconButton } from "../SmallIconButton";

export function PurchaseNutritionCard({
  purchase,
  baseline,
  onFieldChange,
  onComputeCalories,
}: {
  purchase: Purchase;
  baseline: string;
  onFieldChange: <K extends keyof Purchase>(
    field: K,
    value: Purchase[K],
  ) => void;
  onComputeCalories: () => void;
}) {
  return (
    <Card className="flex flex-col gap-4 p-4 border-line bg-surface-card">
      <div className="flex flex-col">
        <SectionLabel>Nährwerte</SectionLabel>
        <span className="text-xs text-ink-muted">{baseline}</span>
      </div>

      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-1">
          <label className="text-xs font-semibold text-ink-muted">
            Kalorien (kcal)
          </label>
          <div className="flex gap-2">
            <div className="flex-1">
              <NumberInput
                data-cy="purchase-kcal-input"
                value={purchase.kcal}
                onValueChange={(val) => onFieldChange("kcal", val || 0)}
                className="flex-1"
              />
            </div>
            <div className="flex flex-1 gap-2 shrink-0">
              <SmallIconButton
                icon={"calculator"}
                onClick={onComputeCalories}
                label={"Kcal berechnen"}
              />
            </div>
            <div className={"flex-1"} />
          </div>
        </div>

        <div className={"flex gap-2"}>
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-ink-muted">
              Fett (g)
            </label>
            <NumberInput
              data-cy="purchase-fat-input"
              value={purchase.fat}
              onValueChange={(val) => onFieldChange("fat", val || 0)}
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-ink-muted">
              KH (g)
            </label>
            <NumberInput
              data-cy="purchase-carbs-input"
              value={purchase.carbs}
              onValueChange={(val) => onFieldChange("carbs", val || 0)}
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-ink-muted">
              Protein (g)
            </label>
            <NumberInput
              data-cy="purchase-protein-input"
              value={purchase.protein}
              onValueChange={(val) => onFieldChange("protein", val || 0)}
            />
          </div>
        </div>
      </div>
    </Card>
  );
}
